import Vue from 'vue'
import App from './App.vue'

import router from '@/router/router'
import store from './store/store'

/* Axios setup */
import axios from 'axios'
Vue.prototype.$axios = axios

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// Add a request interceptor
axios.interceptors.response.use(response => {
    // let time = store.getters['authTokenExp'] - new Date().getTime()
    // let timeLeft = Math.floor(time / 60000).toFixed(1)
    // console.log('test')
    return response
  }, error => {
    // if (error.response.status === 401) {
    //   store.dispatch('authRefreshToken')
    // }
  })


// if (store.getters['authToken']) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['authToken']
// }
axios.defaults.headers.post['Content-Type'] = 'application/json'

/* Custom plugins setup */
import '@/plugins/coreComponents'
import '@/plugins/globalMethods'

//* Plugins */
import '@/plugins/externalPlugins'

//* Mixins */
import accordion from '@/mixins/ui/accordion'
//Validation
import isEmpty from '@/mixins/validation/isEmpty'
import isEmptyObject from '@/mixins/validation/isEmpty'
import emailValidation from '@/mixins/validation/emailValidation'
import validationNotification from '@/mixins/validation/validationNotification'
import formValidationUtil from '@/mixins/validation/validationUtil'
//Mapping
import enumFilterMap from '@/mixins/mapping/enumFilterMap'
import { resolve } from 'core-js/fn/promise'
//Phone formatting
import phoneFormatting from '@/mixins/phone/phoneFormatting'
//Permissions
import isAdmin from '@/mixins/permissions/is-admin'
//Utils
import clearPhoneNumber from '@/mixins/utils/clear-phone-number'


Vue.mixin(accordion)
Vue.mixin(isEmpty)
Vue.mixin(isEmptyObject)
Vue.mixin(emailValidation)
Vue.mixin(formValidationUtil)
Vue.mixin(validationNotification)
Vue.mixin(enumFilterMap)
Vue.mixin(phoneFormatting)
Vue.mixin(isAdmin)
Vue.mixin(clearPhoneNumber)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
